import { render, staticRenderFns } from "./gradeRank.vue?vue&type=template&id=52b3e30c&scoped=true"
import script from "./gradeRank.vue?vue&type=script&lang=js"
export * from "./gradeRank.vue?vue&type=script&lang=js"
import style0 from "./gradeRank.vue?vue&type=style&index=0&id=52b3e30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b3e30c",
  null
  
)

export default component.exports